export default __webpack_public_path__ + "static/media/tiktok.c8e5eb68.png";